import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgCoalition = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 62"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M7.303 61.673h188.628L200 52.135h-3.387l-1.395.5H144.4l-.596-9.167h-30.853v-4.493l2.432-2.733-3.988-.2-.572-3.502h-4.46v-1.303l.482-.551v-1.704l-.481-.603h-2.147l-.193-.404h-1.418v2.71l1.046.552-.198.857h-.35l.35.928 3.391 2.78v1.193l-1.006 1.98v3.474h-2.187l-.198-3.474-.848-.279h-2.366l-.494 2.029h-1.11l-.505-2.225h-3.257v3.949h-2.153l-.454-3.11h-.939v-1.366q.44-.942 0-1.437c-.438-.494-1.54-1.051-2.34-.294q-.802.758 0 1.73l-.266 1.366h-5.28l-.471-6.798 2.317-4.16-2.964-.405-1.115-6.81v-3.361l1.762-1.097-1.275-1.41v-3.256l-.487-2.76V0h-1.206v9.28h-1.495l-.49 2.761h1.473v3.257l-.983 1.409.983 2.082v2.376l-.983 1.48v5.33h-5.226v-1.764l-1.02-1.255-1.258 1.255v1.764h-.618v1.416q3.328.06 7.633 1.846l-1.294 7.738h-2.883a26 26 0 0 0-2.343-1.002q-1.113-.408 0-2.688h-1.594l-.491 3.69-15.08.363q-.38 9.936-3.652 9.935H36.96v-2.01l-1.942-.982-3.516.518-6.718-1.086v.568l5.93.982-1.9 1.563v1.982H0q6.395 7.2 6.806 8.58.412 1.377.497 2.285"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgCoalition
